/* eslint-disable no-console */
import withBookmarkData from './withBookmarkData';
import NBCBookmark from './bookmark-button';

const wrapWithBookmarkData = withBookmarkData();
export default wrapWithBookmarkData(NBCBookmark);
